<div class="flex flex-col items-start justify-between">
  <h4 class="ml-2 text-gray-950 text-sm lg:text-base">
    {{ breadcrumbs[0] ? breadcrumbs[0].label : "" }}
  </h4>
  <p-breadcrumb class="max-w-full" [model]="breadcrumbs"></p-breadcrumb>
</div>
